import { getRuntimeConfig } from '../config/runtime-config';

const config = getRuntimeConfig();

const normalizeWithTrailingSlash = (value: string): string =>
  value.endsWith('/') ? value : `${value}/`;

const withoutTrailingSlash = (value: string): string =>
  value.endsWith('/') ? value.slice(0, -1) : value;

const normalizeApiPath = (path: string): string => {
  const cleanedPath = path.trim().replace(/\/+$/, '');
  const normalizedPath = cleanedPath.length === 0 ? '/' : cleanedPath;

  if (normalizedPath.endsWith('/api')) {
    return normalizedPath;
  }

  if (normalizedPath === '/') {
    return '/api';
  }

  return `${normalizedPath}/api`;
};

export const isKeycloakIDP = config.LOGIN_PROVIDER === 'keycloak';
export const isAzureIDP = !isKeycloakIDP;

export const getAppName = () => config.APP_NAME;
export const getBackendURL = () => config.BACKEND_URL;
export const getApiBaseUrl = () => {
  const backendUrl = config.BACKEND_URL.trim();

  if (/^https?:\/\//i.test(backendUrl)) {
    const parsed = new URL(backendUrl);
    parsed.pathname = normalizeApiPath(parsed.pathname);
    parsed.search = '';
    parsed.hash = '';
    return normalizeWithTrailingSlash(parsed.toString());
  }

  const normalized = withoutTrailingSlash(normalizeWithTrailingSlash(backendUrl));
  return normalizeWithTrailingSlash(normalizeApiPath(normalized));
};
export const getConfigType = () => config.CONFIG_TYPE;

export const getMsalAuthClientId = () => config.AZURE_CLIENT_ID;
export const getMsalAuthTenantId = () => config.AZURE_TENANT_ID;
export const getMsalAuthRedirectUrl = () => config.AZURE_REDIRECT_URL;
export const getMsalAuthScope = () => config.AZURE_SCOPE;

export const getKeycloakAuthServerUrl = () => config.KEYCLOAK_AUTH_SERVER_URL;
export const getKeycloakRealm = () => config.KEYCLOAK_AUTH_REALM;
export const getKeycloakClientId = () => config.KEYCLOAK_AUTH_CLIENT_ID;
